import { useState } from 'react';

import { LDFlags } from '../constants/flags';
import { resolveVisitorRegion } from '../utils/privacy';
import useFlag from './useFlag';
import useOnceWhen from './useOnceWhen';

const usePrivacyChoicesInScope = () => {
  const isPrivacyChoicesEnabled = useFlag(LDFlags.COM_PRIVACY_GTM_GATE);
  const [isInScope, setIsInScope] = useState(false);

  useOnceWhen(isPrivacyChoicesEnabled, () => {
    resolveVisitorRegion()
      .then((region) => setIsInScope(region.in_scope))
      // An unknown region is in scope (FR-12)
      .catch(() => setIsInScope(true));
  });

  return isPrivacyChoicesEnabled && isInScope;
};

export default usePrivacyChoicesInScope;
